import React, { useState, useRef } from 'react';
import { Button, Icon, Dialog } from '@tencent/spaui';
import moment from 'moment';
import _ from 'lodash';
import useDialog from '../../../../leads_component/shared-components/hooks/useDialog';
import WelcomeEditDialog from './WelcomeEditDialog';
import { ListView } from '@tencent/ptp-fe-common';
import { RPCFactory } from '../../../../utils/RequestUtil';
import { LeadsDataFilterShortcut as DATE_SHORTCUTS } from '../../../../consts/Common';
import { CorpSelector } from '../corpSelector';
import '../index.less';
const dialog = Dialog.decorate();

const NOTICE_TYPE_MAP = {
  text: '文本',
  image: '图片',
  link: '图文消息',
  miniprogram: '小程序消息',
  video: '视频',
  file: '文件',
};

const Page = (props) => {
  const lvRef = useRef();
  const [editData, setEditData] = useState({}); // 编辑信息

  const dialogHooks = useDialog({ showDialog: false });

  // 展示的列
  const showColumns = [
    'welcomeMsgName',
    'messageTypeList',
    'salesRange',
    'createdTime',
    'creatorWxWorkUserId',
    'options',
  ];

  const initQuery = {
    timeRange: {
      start_time: moment().subtract(30, 'day').format('YYYY-MM-DD'),
      end_time: moment().add(30, 'day').format('YYYY-MM-DD'),
    },
  };

  const getList = (params) =>
    new Promise((res, rej) => {
      RPCFactory.wechatWelcome
        .getWelcomeMsgList(params)
        .done((data) => {
          const arr = data.entities.map((item) => ({
            _data: item,
            ...item,
            // messageTypeList: NOTICE_TYPE_MAP[item.messageTypeList],
          }));
          res({
            list: arr,
            page_info: {
              total_number: data.page_info.total_number,
            },
          });
        })
        .fail((ret, msg) => rej(msg));
    });

  const reloadList = () => {
    if (typeof lvRef.current.loadList !== 'function') return;
    lvRef.current.loadList();
  };

  const handleEdit = (data) => {
    // e.preventDefault();
    setEditData({ ...data });
    dialogHooks.showAsAddModel();
  };
  const handleDelete = (data) => {
    console.log(data);
    dialog.setProps({
      style: {
        width: '500px',
      },
      title: '提示',
      show: true,
      cancelButton: true,
      submitButton: true,
      children: <div>确定要删除吗</div>,
      onClose() {
        dialog.setProps({
          show: false,
        });
      },
      onSubmit() {
        dialog.setProps({
          show: false,
        });
        RPCFactory.wechatWelcome
          .deleteWelcomeMsgById({ welcomeMsgId: data.welcomeMsgId })
          .done(() => {
            reloadList();
          })
          .fail((ret, msg) => {
            window.alert(`服务器请求出错，出错信息：${msg}`);
          });
      },
      onCancel() {
        dialog.setProps({
          show: false,
        });
      },
    });
  };

  const renderRange = (type, name, value, data) => {
    if (!data.wxWorkUserIdList || data.wxWorkUserIdList.length === 0) return '全部';
    return (
      <div>
        {data.wxWorkUserIdList.map((salesId, index) => (
          <span>
            <ww-open-data type="userName" openid={salesId} />
            {index < data.wxWorkUserIdList.length - 1 ? <span style={{ marginRight: '0px' }}>, </span> : null}
          </span>
        ))}
      </div>
    );
  };
  const renderCreator = (type, name, value, data) => {
    return <ww-open-data type="userName" openid={data.creatorWxWorkUserId} />;
  };
  const renderTime = (type, name, value, data) => {
    return <span>{data.createdTime}</span>;
  };
  const renderOptions = (type, name, value, data) => {
      return (
        <span>
          <a
            onClick={() => {
              handleEdit(data);
            }}
          >
            编辑
          </a>
          <a
            onClick={() => {
              handleDelete(data);
            }}
          >
            删除
          </a>
        </span>
      );
  };

  const renderMessageType = (type, name, value, data) => {
    const messageTypes = data.messageTypeList.map(item => NOTICE_TYPE_MAP[item]);
    return messageTypes.join(',')
  };
  const columnMap = {
    welcomeMsgName: { title: '欢迎语名称' },
    messageTypeList: { title: '欢迎语类型', render: renderMessageType },
    salesRange: { title: '客服范围', render: renderRange },
    createdTime: { title: '创建时间', align: 'center', render: renderTime },
    creatorWxWorkUserId: { title: '创建人', render: renderCreator },
    options: { title: '操作', render: renderOptions },
  };

  const filterControls = [
    {
      name: 'welcomeMsgName',
      title: '欢迎语名称',
      type: 'search',
    },
    {
      name: 'timeRange',
      title: '时间范围',
      type: 'date-picker',
      clearable: false,
      config: {
        type: 'range',
        longestRange: '365',
        optionalStartRelativeDays: '-1000',
        optionalEndRelativeDays: '1000',
        useShortcut: true,
        shortcuts: DATE_SHORTCUTS,
      },
    },
  ];

  const lvOptions = () => ({
    fetchConfig: {
      action: getList,
      $onRequest(params) {
        console.log('request', params);
        const obj = { ...params };
        obj.pageIndex = params.page;
        obj.pageSize = params.page_size;
        delete obj.timeRange;
        delete obj.page;
        delete obj.page_size;
        if (_.isPlainObject(params.timeRange)) {
          obj.startCreateTime = moment(params.timeRange.start_time).format('YYYY-MM-DD');
          obj.endCreateTime = moment(params.timeRange.end_time).format('YYYY-MM-DD');
        }
        return obj;
      },
      $onResponse(data) {
        return data;
      },
      $onError: window.alert,
    },
    toolbarConfig: {
      left: (
        <div className="toolbar-right-group">
          <Button
            displayType="primary"
            className="add-edit-welcome-dialog"
            onClick={() => {
              setEditData({});
              dialogHooks.showAsAddModel();
            }}
          >
            <Icon type="add" />
            添加欢迎语
          </Button>
        </div>
      ),
    },
    filterConfig: {
      resetable: false,
      controls: filterControls,
      customConfigure: null,
      defaultValuesByKey: initQuery,
    },
    batchConfig: null,
    tableConfig: {
      defaultPageSize: 10,
      select: 'single',
      columns: showColumns.map((key) => ({ ...columnMap[key], name: key })),
      optionalConfig: {
        type: 'optional',
        // 列表的唯一字段
        target: 'welcomeMsgId',
        multiple: true,
        canOptional: true,
      },
    },
  });

  return (
    <main className="main" id="main">
      <CorpSelector {...props} onChange={reloadList} />
      <div id="messageList">
        <div className="onlycard">
          <div className="card" style={{ paddingTop: 0 }}>
            <div className="datalist">
              <ListView
                className="lv"
                ref={lvRef}
                options={lvOptions}
              />
            </div>
          </div>
        </div>
        <WelcomeEditDialog
          show={dialogHooks.showDialog}
          editData={editData}
          onSuccess={() => {
            dialogHooks.setShowDialog(false);
            reloadList();
          }}
          onCancel={dialogHooks.onCancel}
        />
      </div>
    </main>

  );
};

export default Page;
